/**
 * Papel de um usuário dentro de uma empresa (ebarn-node,
 * `src/entities/enums/EmpresaUsuarios.ts`) — não confundir com
 * `PerfilUsuario`, enum legado não relacionado.
 */
export enum PapelEmpresa {
  ADMIN = 'ADMIN',
  COLABORADOR = 'COLABORADOR',
  COMPRADOR = 'COMPRADOR',
  GERENTE_COMPRAS = 'GERENTE_COMPRAS',
  APROVADOR = 'APROVADOR'
}

export const PAPEL_EMPRESA_LABEL: Record<PapelEmpresa, string> = {
  [PapelEmpresa.ADMIN]: 'Admin',
  [PapelEmpresa.COLABORADOR]: 'Colaborador',
  [PapelEmpresa.COMPRADOR]: 'Comprador',
  [PapelEmpresa.GERENTE_COMPRAS]: 'Gerente de Compras',
  [PapelEmpresa.APROVADOR]: 'Aprovador'
};
